export const GeneralAdmission = {
  name: '',
  basketNote: {}
}
